import { injectStrict } from '@/injection/injectStrict.ts';
import { ApiKey } from '@/injection/keys.ts';
import { ApiRequestParams } from '@/types/api.type.ts';
import {
    City,
    CitiesPaginator,
    CitiesRequestFilter,
    CitySchema,
    CitiesPaginatorSchema,
    CitiesSchema, CityCreateFormErrorsSchema, CityCreateFormErrors, CityUpdateFormErrorsSchema, CityUpdateFormErrors, CityCreateForm, CityUpdateForm,
} from '@/types/city.type.ts';

class CityRepository
{
    private $Api: any;

    constructor() {
        this.$Api = injectStrict(ApiKey);
    }

    public getCity(id: number): Promise<City>
    {
        const requestParams: ApiRequestParams = {
            segments: { id },
        };

        return new Promise((resolve) => {
            this.$Api.callNew('getCity', requestParams)
                .then(({ data }: any) => {
                    const parsedCity = CitySchema.parse(data);
                    const city: City = parsedCity as unknown as City;

                    resolve(city);
                });
        });
    }

    public getCities(citiesRequestFilter?: CitiesRequestFilter, oAbortController?: AbortController): Promise<CitiesPaginator>
    {
        const requestParams: ApiRequestParams = {
            query: citiesRequestFilter,
        };

        return new Promise((resolve) => {
            this.$Api.callNew('getCities', requestParams, null, oAbortController)
                .then(({ data }: any) => {
                    const parsedCitiesPaginator = CitiesPaginatorSchema.parse(data);
                    const citiesPaginator: CitiesPaginator = parsedCitiesPaginator as unknown as CitiesPaginator;

                    resolve(citiesPaginator);
                });
        });
    }

    public createCity(cityCreateForm: CityCreateForm, oAbortController?: AbortController): Promise<void>
    {
        const requestParams: ApiRequestParams = {
            requestBody: cityCreateForm,
        };

        return new Promise((resolve, reject) => {
            this.$Api.callNew('createCity', requestParams, null, oAbortController)
                .then(() => resolve())
                .catch(({ response: { status, data: { errors } } }: any) => {
                    if (status === 422) {
                        const parsedCreateCityErrors = CityCreateFormErrorsSchema.parse(errors);
                        const createCityErrors: CityCreateFormErrors = parsedCreateCityErrors as unknown as CityCreateFormErrors;

                        reject(createCityErrors);
                    }
                    else {
                        reject();
                    }
                });
        });
    }

    public updateCity(id: number, cityUpdateForm: CityUpdateForm, oAbortController?: AbortController): Promise<void>
    {
        const requestParams: ApiRequestParams = {
            segments: { id },
            requestBody: cityUpdateForm,
        };

        return new Promise((resolve, reject) => {
            this.$Api.callNew('updateCity', requestParams, null, oAbortController)
                .then(() => resolve())
                .catch(({ response: { status, data: { errors } } }: any) => {
                    if (status === 422) {
                        const parsedUpdateCityErrors = CityUpdateFormErrorsSchema.parse(errors);
                        const updateCityErrors: CityUpdateFormErrors = parsedUpdateCityErrors as unknown as CityUpdateFormErrors;

                        reject(updateCityErrors);
                    }
                    else {
                        reject();
                    }
                });
        });
    }

    public getAllCities(): Promise<City[]>
    {
        return new Promise((resolve) => {
            this.$Api.callNew('getAllCities')
                .then(({ data }: any) => {
                    const parsedCities = CitiesSchema.parse(data);
                    const cities = parsedCities as unknown as City[];

                    resolve(cities);
                });
        });
    }
}

export default CityRepository;
